var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCanvasEventTiktok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 101,
    viewBox: "0 0 100 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 50,
    transform: "matrix(-4.37114e-08 1 -1 -1.05524e-06 100 0.279053)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20.2791,
    width: 60,
    height: 59.9999,
    rx: 30,
    fill: "#FFE9F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.5818 56.9015C40.5816 57.5889 40.7167 58.2696 40.9796 58.9047C41.2425 59.5399 41.6279 60.117 42.1139 60.6031C42.5998 61.0893 43.1768 61.4749 43.8119 61.738C44.4469 62.0011 45.1275 62.1365 45.8149 62.1365C47.2174 62.1575 48.5722 61.628 49.5887 60.6616C50.6053 59.6952 51.2025 58.3689 51.2524 56.9672L51.3124 33.4041L56.1462 33.4041C56.3657 35.5039 57.3164 37.4596 58.8321 38.9294C60.3477 40.3991 62.3319 41.2892 64.4374 41.444L64.4374 47.0597C64.1618 47.0859 63.8843 47.1009 63.6068 47.1009C62.1109 47.102 60.6384 46.7301 59.3224 46.0191C58.0063 45.308 56.8883 44.2802 56.0693 43.0284L56.0693 56.9034C56.0693 58.9315 55.4679 60.9141 54.3411 62.6004C53.2144 64.2867 51.6128 65.6011 49.7391 66.3772C47.8654 67.1533 45.8035 67.3564 43.8144 66.9607C41.8252 66.5651 39.9981 65.5884 38.564 64.1543C37.1299 62.7202 36.1533 60.8931 35.7576 58.9039C35.3619 56.9148 35.565 54.853 36.3411 52.9792C37.1172 51.1055 38.4316 49.504 40.1179 48.3772C41.8042 47.2504 43.7868 46.649 45.8149 46.649C46.0287 46.649 46.2387 46.6678 46.4487 46.6809L46.4487 51.7434C46.2388 51.7098 46.0272 51.6885 45.8149 51.6797C44.429 51.6797 43.0996 52.2295 42.1185 53.2084C41.1374 54.1874 40.5848 55.5156 40.5818 56.9015Z",
    fill: "#121212"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanvasEventTiktok);
export default __webpack_public_path__ + "static/media/canvas_event_tiktok.eb88ff3590ddd7c836d0ca1bae887059.svg";
export { ForwardRef as ReactComponent };